<template>
  <MainLayout bg-color="white">
    <template #content>
      <div class="p-10">
        Sidebar UI Testing
      </div>
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from '../../layouts/MainLayout.vue'

export default {
  name: 'SidebarUITesting',
  components: {
    MainLayout
  }
}
</script>